import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "CampaignSearchDropdownItemRow CampaignSearchDropdownItemUserRow" }
const _hoisted_2 = { class: "CampaignSearchUserName" }
const _hoisted_3 = { class: "CampaignSearchUserEmail" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "CampaignSearchDropdownItemContainer",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.name), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.email), 1 /* TEXT */)
    ])
  ]))
}